import React from 'react';
import Marker from '@molecules/maps/marker'
import styled from "styled-components";

function Location({className, map_type, center, tapFullscreen = false, zoom_control = true, touchZoom = true}) {
    const mapOptions = {
        scrollWheelZoom: false,
        zoomControl: false,
        dragging: false,
        fullscreenControl: true,
        maxZoom: 18,
        attributionControl: false,
		touchZoom: touchZoom,
    };

    return (
        <div className={className ? className : ''}>

            <h2>موقعیت</h2>
            <div className="mt-24">
                <MapContainer className="rounded-8">
                    <Marker
                        options={mapOptions}
                        center={center}
                        zoom={17}
                        type={map_type}
                        zoom_control={zoom_control}
						tapFullscreen={tapFullscreen}
                    />
                </MapContainer>
            </div>
        </div>
    )
}

function propsAreEqual(prevProps, nextProps) {
    return JSON.stringify(prevProps.center) === JSON.stringify(nextProps.center);
}

export default React.memo(Location, propsAreEqual);

const MapContainer = styled.div`
    width: 100%;
    height: 390px;
    background-color: ${props => props.theme.gray250};
    
    @media (max-width: ${props => props.theme.screenXsMax}) {
        height: 260px;
    }
`;